<template>
  <div>
    <div id="postNotFound">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 not-found mb-5 text-center">
            <img src="/static/images/articulos_not_found.png" />
            <h2>Lo sentimos, no hemos encontrado lo que buscabas.</h2>
            <div class="divider-01"/>
          </div>
          
        </div>
  
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  
  methods: {
    isMobile() {
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    }
  }
}
</script>

<style scoped>

  .divider-01 {
    height: 5px;
    width: 16%;
    background-color: #E8404E;
    border-radius: 3px;
    margin: 20px auto 70px auto;
    
  }

  .not-found img{
    width: 60%;
    }

  .not-found p{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    display: flex;
    line-height: 140.62%;
    text-align: center;
    color: #1E2245;
  }

  .not-found h2{
    font-family: Muli;
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 65px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #BDBDBD;
    padding-top:20px;
  }

  .article{
    margin-bottom:auto;
    text-align: justify;
  }

  .article img {
    width: 100%;
    height: 35vh;
    border-radius: 10px;
  }

  .article p {
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 25px;
    color: #1E2245;
    padding:15px;
  }

  .article a{
    padding-left:15px ;
    margin-bottom:10px;
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #1E2245;
  }
  
  @media(max-width: 992px){
    .article img {
      height: 100%;
    }
  }

  @media(max-width: 768px){
  
    .not-found img{
    width: 100%;
    }
  }

</style>
